module.exports = __webpack_public_path__ + "img/Logo_Header.32ef131c.svg";